import ComponentModal from './ComponentModal';

import './ComponentModal.scss';

export default ComponentModal;
